import {Pipe, PipeTransform} from '@angular/core';

export interface MetricOption {
  option: string;
  value: number;
}

@Pipe({
  name: 'trackerMetricOptionsToStrings',
  standalone: true,
})
export class TrackerMetricOptionsToStringsPipe implements PipeTransform {
  transform(options: MetricOption[]): string[] {
    if (!options || !Array.isArray(options)) {
      return [];
    }

    return options.map(option => option.option);
  }
}
